import { slugs } from '@/constants/slugs'
import { Maybe } from '@/utils/types'

interface PremierePartnerParams {
  vendorId: Maybe<string>
  theaterSlug: Maybe<string>
  experimentValue?: unknown
}

export const PREMIERE_VENDORS = {
  MEGAPLEX_MX: 'MEGAPLEX_MX',
  LOOK: 'LOOK',
} as const

export const isPremierePartnerVenue = ({ vendorId, theaterSlug, experimentValue }: PremierePartnerParams) => {
  if (!vendorId) return false
  if (experimentValue !== 'badge' && experimentValue !== 'label') return false

  return isPremierePartnerVenueByVendor({ vendorId, theaterSlug })
}

export const isPremierePartnerVenueByVendor = ({
  vendorId,
  theaterSlug,
}: {
  vendorId: Maybe<string>
  theaterSlug: Maybe<string>
}) => {
  if (!vendorId) return false

  return (
    (vendorId === PREMIERE_VENDORS.MEGAPLEX_MX && theaterSlug === slugs.truthAndTreason) ||
    (vendorId === PREMIERE_VENDORS.LOOK && theaterSlug === slugs.senior)
  )
}
